import ActorCardComponent from './ActorCardComponent';

export default ActorCardComponent;
